module.exports = __webpack_public_path__ + "img/favicon.736bf5f5.jpg";